import api from './api'

export function fetchModulo(modulo) {
  return api.get(`/estruturacao/modulos/${modulo}`)
}

export function fetchModuloAdmin(modulo) {
  return api.get(`/estruturacao/admin/modulos/${modulo}`)
}

export function fetchAula(aulaId) {
  return api.get(`/estruturacao/aulas/${aulaId}`)
}

export function saveProgresso(aulaId, payload) {
  return api.put(`/estruturacao/aulas/${aulaId}/progresso`, payload)
}

export function fetchComentarios(aulaId, { limit = 20, offset = 0 } = {}) {
  return api.get(`/estruturacao/aulas/${aulaId}/comentarios`, {
    params: { limit, offset }
  })
}

export function postComentario(aulaId, mensagem) {
  return api.post(`/estruturacao/aulas/${aulaId}/comentarios`, { mensagem })
}

export function downloadMaterialUrl(materialId) {
  const base = api.defaults.baseURL || ''
  const token = localStorage.getItem('token')
  return `${base}/estruturacao/materiais/${materialId}/download${token ? `?token=${encodeURIComponent(token)}` : ''}`
}

export async function downloadMaterial(materialId, filename) {
  const response = await api.get(`/estruturacao/materiais/${materialId}/download`, {
    responseType: 'blob'
  })
  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename || 'download')
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

// Admin
export function createCategoria(modulo, data) {
  return api.post(`/estruturacao/admin/modulos/${modulo}/categorias`, data)
}

export function updateCategoria(categoriaId, data) {
  return api.put(`/estruturacao/admin/categorias/${categoriaId}`, data)
}

export function deleteCategoria(categoriaId) {
  return api.delete(`/estruturacao/admin/categorias/${categoriaId}`)
}

export function createAula(categoriaId, data) {
  return api.post(`/estruturacao/admin/categorias/${categoriaId}/aulas`, data)
}

export function updateAula(aulaId, data) {
  return api.put(`/estruturacao/admin/aulas/${aulaId}`, data)
}

export function deleteAula(aulaId) {
  return api.delete(`/estruturacao/admin/aulas/${aulaId}`)
}

export function addMaterialLink(aulaId, data) {
  return api.post(`/estruturacao/admin/aulas/${aulaId}/materiais/link`, data)
}

export function uploadMaterial(aulaId, data) {
  return api.post(`/estruturacao/admin/aulas/${aulaId}/materiais/upload`, data)
}

export function deleteMaterial(materialId) {
  return api.delete(`/estruturacao/admin/materiais/${materialId}`)
}
